module.exports = __webpack_public_path__ + "static/media/icon_duplicate-data-issue.8bdfe6d9.svg";